<script>
  import { Toast } from 'flowbite-svelte';
  import { fly } from 'svelte/transition';
  import { _ } from 'svelte-i18n';

  export let shortlink = '';
  let isShowingToast = false;

  $: {
    if (isShowingToast) {
      setTimeout(() => {
        isShowingToast = false;
      }, 2000);
    }
  }

  function onClick(event) {
    event.stopPropagation();
    navigator.clipboard.writeText(shortlink);
    isShowingToast = true;
  }
</script>

<button
  on:click={onClick}
  classes="grid w-100 h-10 text-gray-900 hover:text-blue-500"
>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    class="hover:stroke-blue-700 hover:text-blue-600"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_211)">
      <path
        d="M17 8.83334H18.8333C19.2015 8.83334 19.5 9.13182 19.5 9.50001V18.8333C19.5 19.2015 19.2015 19.5 18.8333 19.5H9.49998C9.13179 19.5 8.83331 19.2015 8.83331 18.8333V17"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.5 5.16667C4.5 4.79847 4.79848 4.5 5.16667 4.5H14.5C14.8682 4.5 15.1667 4.79848 15.1667 5.16667V14.5C15.1667 14.8682 14.8682 15.1667 14.5 15.1667H5.16667C4.79847 15.1667 4.5 14.8682 4.5 14.5V5.16667Z"
        stroke="currentColor"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_211">
        <rect width="16" height="16" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
</button>

<div class="fixed bottom-5 right-0 z-10 flex w-full justify-center">
  <Toast
    transition={fly}
    params={{ x: 200, delay: 150 }}
    bind:open={isShowingToast}
    color="none"
    class="mb-2 !bg-gray-700 text-white drop-shadow-2xl"
  >
    <svelte:fragment slot="icon">
      <svg
        aria-hidden="true"
        class="h-5 w-5"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        ><path
          fill-rule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          clip-rule="evenodd"
        /></svg
      >
      <span class="sr-only">Check icon</span>
    </svelte:fragment>
    {$_('components.copyButton.toast.linkCopySuccess', {
      default: 'Link copied successfully.',
    })}
  </Toast>
</div>
